module.exports = __webpack_public_path__ + "img/equipment.cfbb65d1.svg";